import { expandBorderLeft, expandBorderRight, expandBorderTop } from "@gadgetinc/widgets";
import { styled, useStyletron } from "baseui";
import { StyledTable } from "baseui/table-semantic";
import React from "react";
import type { StyleObject } from "styletron-standard";
export { StyledTableBodyCell as TD, StyledTableHeadCell as TH, StyledTableBodyRow as TR } from "baseui/table-semantic";

export const Table = (props: { children: React.ReactNode; $style?: StyleObject }) => {
  const [css, $theme] = useStyletron();
  return (
    <div
      className={css({
        marginBottom: $theme.sizing.scale600,
        borderRadius: $theme.borders.radius200,
        ...expandBorderTop($theme.borders.border300),
        ...expandBorderLeft($theme.borders.border300),
        ...expandBorderRight($theme.borders.border300),
        // make wide tables horizontally scroll without breaking column alignment
        overflowX: "auto",
        width: "100%",
      })}
    >
      <StyledTable
        $style={{
          borderCollapse: "separate",
          width: "100%",
          ...props.$style,
        }}
        data-docscontent="true"
      >
        {props.children}
      </StyledTable>
    </div>
  );
};

export const THead = styled("thead", {});
export const TBody = styled("tbody", {});
